import React from "react";

import './styles.css'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import CloseIcon from '@mui/icons-material/Close';
import {
  IconButton,
  //Container,
  TextField,
  //Modal,
  Box,
  Typography,
  Button,
} from '@mui/material';

import { LoadingButton } from '@mui/lab';


function EditSessao(props){
  //const [choose, setChoose] = useState('Disponível');

  //const handleChoose = () => {
  //  setChoose('Escolhido');
  //}

  return (props.trigger) ? (
    <Box className="popup">
     
        <Box className="popup-inner-card" >

            <Typography variant="h5">Editar Informações do Plano ''{props.sessao.title}''</Typography>
            <Box margin={2}>
                <TextField sx={{marginBottom:2}} fullWidth label="Nome do Plano" defaultValue={props.sessao.title}/>
                <TextField sx={{marginBottom:2}} multiline fullWidth rows={4}label="Descrição" defaultValue={props.sessao.text}/>
              

                <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    //loading={isSubmitting}
                    onClick={() => props.setTrigger(false)}
                    >
                    Guardar
                </LoadingButton>
            </Box>
                    
                
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
       
    </Box>
      /*
      <div className="popup">
        <div className="popup-inner">
            <button className="close-btn" onClick={() => props.setTrigger(false)}>
            Fechar
            </button>
            {props.children}
        </div>
    </div>
    */
  ) : "";
}
export default EditSessao
